import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { removeOrAddToListByElement } from 'src/app/helpers/helpers';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SessionInfo, NestedProgramInfo, ExhibitorStandSelection } from 'src/app/store/reselectors/performerSponsors.reselector';
import { Wrapper } from '../wrapper.component';
import { DialogWrapperComponent } from './../wrappers/dialog-wrapper.component';
import { Program, Session } from 'globals/store/programs.data';
import { ToggleButtonWrapperComponent } from '../buttons/toggle-button-wrapper.component';
import { BigAndGreyComponent } from '../cards/big-and-grey.component';
import { ListHasStringPipe } from 'src/app/services/pipes/listHasString.pipe';
import { CommonModule, DatePipe } from '@angular/common';
import { SearchBarComponent } from '../search-bar';
import { flatten, jsonCopyObject } from 'globals/helpers/helpers';
import { ExpandingWrapperComponent } from '../wrappers/expanding-wrapper.component';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';

@Component({
    selector: 'simple-session-selector',
    template: `
<dialog-wrapper
  #dialogWrapper
  [disabled]="false"
  [smallTitle]="true"
  [giveMeTwenty]="true"
  [dontGiveExtraSpacing]="true"
  successLabel="SAVE"
  [dialogTitle]="'Sessions'"
  [titleHeight]="40"
  [data]="{ position: { top: data.y, left: data.x }, dialogRef: dialogRef }"
  [showClose]="true"
  [cancelLeft]="true"
  (close)="cancel()"
  (cancel)="cancel()"
  (submit)="save()"
>
  <ng-container *ngFor="let day of data.program.sessions">
    <toggle-button [selected]="sessionIds | listHasString:session.id" *ngFor="let session of day.sessions | idsToItems:data.program.sessions_obj; trackBy: trackBySession" (select)="toggleSession(session.id)">
      <big-and-grey [boldTitle]="false" [theTitle]="session.title" greyText="{{ session.start }} - {{ session.end }}, {{ (day.day ? day.day : day.date | date: 'd MMMM y') }}" ></big-and-grey>
    </toggle-button>
  </ng-container>
</dialog-wrapper>

`,
    styleUrls: ['./session-selector.dialog.scss'],
    standalone: true,
    imports: [DialogWrapperComponent, CommonModule, ToggleButtonWrapperComponent, BigAndGreyComponent, ListHasStringPipe, IdsToItemsPipe, DatePipe]
})
export class SimpleSessionSelectorDialogComponent extends Wrapper<SimpleSessionSelectorDialogComponent> implements OnInit {
  sessionIds: string[] = []

  @ViewChild('dialogWrapper') dialogWrapper: DialogWrapperComponent;
  constructor(public dialogRef: MatDialogRef<SimpleSessionSelectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SimpleSessionSelectorData, private changeDetectorRef: ChangeDetectorRef
  ) { 
    super() 
    const { program, sessionIds } = this.data
    this.sessionIds = [...sessionIds ]
  }

  ngOnInit() {

  }

  trackBySession(index, sessionInfo: Session) {
    return sessionInfo.id
  }

  resize() {
    // console.log("SHOULD BE RESIZING?")
    this.dialogWrapper.fitChildrenWithDelay(300, 40);
  }

  toggleSession(sessionId: string) {
    if (this.data.singleSelection) {
      this.dialogRef.close(sessionId)
      return
    }
    removeOrAddToListByElement(this.sessionIds, sessionId)
    this.sessionIds = [...this.sessionIds]
    this.changeDetectorRef.detectChanges()
  }

  save() { 
    this.dialogRef.close(this.sessionIds)
  }

  cancel() {
    this.dialogRef.close(null)
  }

}

@Component({
    selector: 'session-selector',
    template: `
<dialog-wrapper
  *ngIf="{ stands: !!data.isStands } as vars"
  #dialogWrapper
  [disabled]="!selectedCount"
  [smallTitle]="true"
  [giveMeTwenty]="true"
  [dontGiveExtraSpacing]="true"
  successLabel="SAVE"
  [dialogTitle]="vars.stands ? 'Stands' : 'Sessions'"
  [titleHeight]="40"
  [data]="{ position: { top: data.y, left: data.x }, dialogRef: dialogRef }"
  [showClose]="true"
  [cancelLeft]="true"
  (close)="cancel()"
  (cancel)="cancel()"
  (submit)="save()"
>
  <search-bar [debounceTime]="300" [gray]="true" placeholder="Search sessions" (keyword)="onSearchInput($event)"></search-bar>
  <expanding-wrapper (onToggle)="resize()" [title]="programInfo.programTitle" *ngFor="let programInfo of nestedProgramList; index as pI; trackBy: trackByProgram">
    <ng-container *ngIf="vars.stands">
      <toggle-button [enabled]="!stand.disabled" [selected]="stand.selected" *ngFor="let stand of programInfo.standList; index as sI; trackBy: trackByStand" (select)="stand.message ? null : toggleItem(pI, sI, 'standList')">
        <big-and-grey [boldTitle]="false" [theTitle]="stand.name" [greyText]="stand.message || ''" ></big-and-grey>
      </toggle-button>
    </ng-container>
    <ng-container *ngIf="!vars.stands">
      <toggle-button [selected]="session.selected" *ngFor="let session of programInfo.sessionList; index as sI; trackBy: trackBySession" (select)="toggleItem(pI, sI)">
        <big-and-grey [boldTitle]="false" [theTitle]="session.title" greyText="{{ session.start }} - {{ session.end }}, {{ (session.day ? session.day : session.date | date: 'd MMMM y') }}" ></big-and-grey>
      </toggle-button>
    </ng-container>

  </expanding-wrapper>

  
</dialog-wrapper>

`,
    styleUrls: ['./session-selector.dialog.scss'],
    standalone: true,
    imports: [DialogWrapperComponent, CommonModule, SearchBarComponent, ToggleButtonWrapperComponent, BigAndGreyComponent, DatePipe, ExpandingWrapperComponent]
})
export class SessionSelectorDialogComponent extends Wrapper<SessionSelectorDialogComponent> implements OnInit {
  nestedProgramList: NestedProgramInfo[] = []
  selectedCount = 0
  @ViewChild('dialogWrapper') dialogWrapper: DialogWrapperComponent;

  constructor(public dialogRef: MatDialogRef<SessionSelectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SessionSelectorData
  ) { super() }

  ngOnInit() {
    const { nestedProgramList, x, y } = this.data
    this.nestedProgramList = jsonCopyObject(nestedProgramList)
    // this.dialogRef.updatePosition({ top: y + 'px', left: x + 'px' });
  }
  
  trackByProgram(index, sessionProgram: NestedProgramInfo) {
    return sessionProgram.programId
  }

  trackBySession(index, sessionInfo: SessionInfo) {
    return sessionInfo.id
  }

  trackByStand(index, stand: ExhibitorStandSelection) {
    return stand.id
  }

  resize() {
    // console.log("SHOULD BE RESIZING?")
    this.dialogWrapper.fitChildrenWithDelay(300, 40);
  }

  deselectAll() {
    this.nestedProgramList.forEach(l => l.sessionList.forEach(s => s.selected =false))
    this.selectedCount = 0
  }

  toggleItem(programIndex: number, itemIndex: number, type: 'standList' | 'sessionList' = 'sessionList') {

    const item = this.nestedProgramList[programIndex][type][itemIndex]
    if (this.data.singleSelection) {
      this.deselectAll()
      item.selected = true 
      this.selectedCount = 1
      return
    }

    item.selected = !item.selected
    if (item.selected) {
      this.selectedCount++
    } else {
      this.selectedCount--
    }
  }

  onSearchInput(keyword: string) {
    // console.log({ keyword })
    this.nestedProgramList = !keyword ? this.data.nestedProgramList : this.data.nestedProgramList.map(p => {
      keyword = keyword.toLocaleUpperCase()
      const sessionList = p.sessionList.filter(s => (s.title && s.title.toLocaleUpperCase().includes(keyword)) || (s.description && s.description.toLocaleUpperCase().includes(keyword)))
      return p.programTitle && p.programTitle.toLocaleUpperCase().includes(keyword) ? p : sessionList.length ? {...p, sessionList } : null 
    }).filter(p => p)
  }

  save() { 
    if (this.data.singleSelection) {
      const updatedSession = flatten(this.nestedProgramList.map(l => l.sessionList)).filter(s => s.selected)[0]
      console.log(updatedSession, flatten(this.nestedProgramList.map(l => l.sessionList)).filter(s => s.selected))
      this.dialogRef.close(updatedSession.id)
      return
    } else if (!this.data.exhibitorId) {
      const updatedSessions = flatten(this.nestedProgramList.map(l => l.sessionList)).filter(s => s.selected)
      if (this.data.performerId) {
        this.performerService.addPerformerToMultipleSessions(updatedSessions, this.data.performerId)
      } else if (this.data.sponsorId) {
        this.sponsorService.addSponsorToMultipleSessions(updatedSessions, this.data.sponsorId)
      } else if (this.data.attendeeId) {
        this.programService.tagEntityToMultipleSessions(updatedSessions, this.data.attendeeId, 'attendeeTags')
      }
    } else {
      const addedStands: string[] = flatten(this.nestedProgramList.map(l => l.standList)).filter(s => s.selected).map(s => s.id)
      this.exhibitorService.addExhibitorStands(addedStands, this.data.exhibitorId, 'exhibitor')
    }
    this.dialogRef.close()
  }

  cancel() {
    this.dialogRef.close()
  }
  


}

export interface SessionSelectorData {
  nestedProgramList: NestedProgramInfo[]
  performerId?: string
  sponsorId?: string
  exhibitorId?: string
  attendeeId?: string
  singleSelection?: boolean
  isStands?: boolean
  x: number
  y: number
}

export interface SimpleSessionSelectorData {
  program: Program
  sessionIds: string[]
  singleSelection?:boolean 
  x: number
  y: number
}